import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row, Spinner } from "reactstrap"
import api from "API/Api"
import SweetAlert from "react-bootstrap-sweetalert"
import PageLoader from "./../../assets/loading/pageLoad1.gif"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"

const VLCCIncentives = () => {
  const { canDelete, MODULE } = usePermissions()
  const MID = MODULE.VLCC_INCENTIVES
  const [pageLoad, setPageLoad] = useState(true)
  const [tab, setTab] = useState(1)
  const [result, setResult] = useState(null)

  // Master data
  const [companies, setCompanies] = useState([])
  const [allPlants, setAllPlants] = useState([])
  const [allCCs, setAllCCs] = useState([])
  const [allRoutes, setAllRoutes] = useState([])
  const [allVlccs, setAllVlccs] = useState([])
  const [allProducers, setAllProducers] = useState([])
  const [charts, setCharts] = useState([])

  // Cascading
  const [cPlants, setCPlants] = useState([])
  const [cCCs, setCCCs] = useState([])
  const [cRoutes, setCRoutes] = useState([])
  const [cVlccs, setCVlccs] = useState([])
  const [cProducers, setCProducers] = useState([])

  // Form
  const [fApplyTo, setFApplyTo] = useState("1")
  const [fCompany, setFCompany] = useState("")
  const [fPlant, setFPlant] = useState("")
  const [fCC, setFCC] = useState("")
  const [fRoute, setFRoute] = useState("")
  const [fVlcc, setFVlcc] = useState("")
  const [fProducer, setFProducer] = useState("")
  const [fMilkType, setFMilkType] = useState("3")
  const [fSession, setFSession] = useState("3")
  const [fChart, setFChart] = useState("")
  const [fFrom, setFFrom] = useState("")
  const [fLimitValidity, setFLimitValidity] = useState("0")
  const [fValidUpto, setFValidUpto] = useState("")

  // Preview
  const [previewData, setPreviewData] = useState([])
  const [previewLoading, setPreviewLoading] = useState(false)
  const [previewChecked, setPreviewChecked] = useState({})
  const [previewAllChecked, setPreviewAllChecked] = useState(false)
  const [applyingSelected, setApplyingSelected] = useState(false)

  // Tab data
  const [tabData, setTabData] = useState([])
  const [tabLoading, setTabLoading] = useState(false)
  const [search, setSearch] = useState("")
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [page, setPage] = useState(1)
  const perPage = 50

  // Alerts
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [confirmType, setConfirmType] = useState("delete")
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  const a = r => { const d = r.data?.data; return Array.isArray(d) ? d : d?.data || [] }
  const showCompany = companies.length > 1

  const fetchMaster = useCallback(async () => {
    try {
      const [co, pl, cc, rt, vc, pr, ch] = await Promise.all([
        api.get("companies"), api.get("plants"), api.get("centers"),
        api.get("routes"), api.get("collection-centers"), api.get("producers"),
        api.get("active-incentive-charts")
      ])
      setCompanies(a(co)); setAllPlants(a(pl)); setAllCCs(a(cc))
      setAllRoutes(a(rt)); setAllVlccs(a(vc)); setAllProducers(a(pr))
      setCharts(Array.isArray(ch.data?.data) ? ch.data.data : [])
    } catch (e) { console.error(e) }
    setPageLoad(false)
  }, [])

  useEffect(() => { fetchMaster() }, [fetchMaster])

  // Cascading handlers
  const onCompanyChange = async v => {
    setFCompany(v); setFPlant(""); setFCC(""); setFRoute(""); setFVlcc(""); setFProducer("")
    setCPlants([]); setCCCs([]); setCRoutes([]); setCVlccs([]); setCProducers([]); setPreviewData([])
    if (v) { try { setCPlants(a(await api.get("plants-by-company/" + v))) } catch (e) { } }
  }
  const onPlantChange = async v => {
    setFPlant(v); setFCC(""); setFRoute(""); setFVlcc(""); setFProducer("")
    setCCCs([]); setCRoutes([]); setCVlccs([]); setCProducers([]); setPreviewData([])
    if (v) { try { setCCCs(a(await api.get("chillings-by-plant/" + v))) } catch (e) { } }
  }
  const onCCChange = async v => {
    setFCC(v); setFRoute(""); setFVlcc(""); setFProducer("")
    setCRoutes([]); setCVlccs([]); setCProducers([]); setPreviewData([])
    if (v) { try { setCRoutes(a(await api.get("route-cc/" + v))) } catch (e) { } }
  }
  const onRouteChange = async v => {
    setFRoute(v); setFVlcc(""); setFProducer("")
    setCVlccs([]); setCProducers([]); setPreviewData([])
    if (v) { try { const r = await api.get("collection-center-route/" + v); setCVlccs(Array.isArray(r.data?.data) ? r.data.data : r.data?.data?.data || []) } catch (e) { } }
  }
  const onVlccChange = async v => {
    setFVlcc(v); setFProducer(""); setCProducers([]); setPreviewData([])
    if (v) { try { setCProducers(a(await api.get("producer-center/" + v))) } catch (e) { } }
  }

  // Load tab data
  const loadTabData = useCallback(async (t) => {
    setTabLoading(true); setCheckedItems({}); setParentChecked(false); setSearch(""); setPage(1)
    try {
      const ep = { 2: "vlcc-incentive-approvals", 3: "producer-incentive-approvals", 4: "vlcc-incentive-updates", 5: "producer-incentive-updates" }
      if (ep[t]) { const r = await api.get(ep[t]); setTabData(Array.isArray(r.data?.data) ? r.data.data : []) }
    } catch (e) { setTabData([]) }
    setTabLoading(false)
  }, [])

  useEffect(() => { if (tab >= 2) loadTabData(tab) }, [tab, loadTabData])


  // Preview: Show button handler
  const handleShow = async () => {
    if (!fChart) return setResult({ ok: false, msg: "Incentive Chart is required." })
    if (!fFrom) return setResult({ ok: false, msg: "Effective From Date is required." })
    if (fLimitValidity === "1" && !fValidUpto) return setResult({ ok: false, msg: "Valid Upto is required." })
    setPreviewLoading(true); setResult(null); setPreviewData([]); setPreviewChecked({}); setPreviewAllChecked(false)
    try {
      const resp = await api.post("vlcc-incentive-preview", {
        applyTo: fApplyTo, company: fCompany || null, plant: fPlant || null,
        chillingCenter: fCC || null, route: fRoute || null, vlcc: fVlcc || null,
        producer: fProducer || null, milkType: fMilkType, incentiveChart: fChart
      })
      if (resp.data?.success) {
        setPreviewData(resp.data.data || [])
      } else { setResult({ ok: false, msg: resp.data?.message || "Failed to load preview." }) }
    } catch (e) { setResult({ ok: false, msg: e.response?.data?.message || e.message }) }
    setPreviewLoading(false)
  }

  // Apply selected
  const handleApplySelected = async () => {
    const ids = Object.keys(previewChecked).filter(k => previewChecked[k])
    if (ids.length === 0) return setResult({ ok: false, msg: "Select at least one item." })
    setApplyingSelected(true); setResult(null)
    try {
      const resp = await api.post("bulk-apply-vlcc-incentives", {
        applyTo: fApplyTo, company: fCompany || null, plant: fPlant || null,
        chillingCenter: fCC || null, route: fRoute || null, vlcc: fVlcc || null,
        entityIds: ids, milkType: fMilkType, session: fSession,
        incentiveChart: fChart, from: fFrom, limitValidity: fLimitValidity,
        validUpto: fLimitValidity === "1" ? fValidUpto : null
      })
      if (resp.data?.success) {
        setResult({ ok: true, msg: resp.data.message })
        setPreviewData([]); setPreviewChecked({}); setPreviewAllChecked(false)
      } else { setResult({ ok: false, msg: resp.data?.message || "Apply failed." }) }
    } catch (e) { setResult({ ok: false, msg: e.response?.data?.message || e.message }) }
    setApplyingSelected(false)
  }

  // Preview check toggles
  const togglePreviewAll = () => {
    const v = !previewAllChecked; setPreviewAllChecked(v)
    const m = {}; previewData.forEach(r => m[r.entityId] = v); setPreviewChecked(m)
  }
  const togglePreviewOne = id => {
    setPreviewChecked(p => {
      const n = { ...p, [id]: !p[id] }
      setPreviewAllChecked(previewData.every(r => n[r.entityId]))
      return n
    })
  }
  const previewSelectedCount = Object.keys(previewChecked).filter(k => previewChecked[k]).length

  // Helpers
  const getName = (list, id, key = "name") => { const r = list.find(x => String(x.id) === String(id)); return r ? (r[key] || r.name || r.chartName || id) : id || "All" }
  const milkLbl = v => ({ "1": "Cow", "2": "Buffalo", "3": "Both" }[String(v)] || v)
  const sessLbl = v => ({ "1": "AM", "2": "PM", "3": "Both" }[String(v)] || v)
  const getProducerName = id => { const p = allProducers.find(x => String(x.id) === String(id)); return p ? (p.producerName || p.name || id) : id || "\u2014" }

  // Bulk actions for tabs
  const selectedIds = Object.keys(checkedItems).filter(k => checkedItems[k])
  const selectedCount = selectedIds.length
  const filtered = useMemo(() => {
    if (!search) return tabData
    const s = search.toLowerCase()
    return tabData.filter(r => JSON.stringify(r).toLowerCase().includes(s))
  }, [tabData, search])
  const totalPages = Math.max(1, Math.ceil(filtered.length / perPage))
  const paged = useMemo(() => filtered.slice((page - 1) * perPage, page * perPage), [filtered, page])
  useEffect(() => setPage(1), [search])
  const handleCheckbox = id => setCheckedItems(p => { const n = { ...p, [id]: !p[id] }; setParentChecked(filtered.every(r => n[r.id])); return n })
  const handleParentCheckbox = () => { const v = !parentChecked; setParentChecked(v); const m = {}; filtered.forEach(r => m[r.id] = v); setCheckedItems(m) }

  const handleBulkAction = async (type) => {
    try {
      if (type === "delete") await api.post("bulk-delete-vlcc-incentives", { ids: selectedIds })
      else await api.post("bulk-approve-vlcc-incentives", { ids: selectedIds })
      loadTabData(tab)
      setdynamic_title(type === "delete" ? "Deleted" : "Approved")
      setdynamic_description(type === "delete" ? "Selected incentive(s) deleted." : "Selected incentive(s) approved.")
      setsuccess_dlg(true)
    } catch (e) { alert(e.message) }
  }
  const handleSingleApprove = async (id) => {
    try { await api.put("approve-vlcc-incentive/" + id); loadTabData(tab) } catch (e) { alert(e.message) }
  }

  const ib = (bg, icon, title, onClick, dis) => <button title={title} onClick={onClick} disabled={dis} style={{ width: 32, height: 32, borderRadius: 4, background: bg, color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14, cursor: "pointer", opacity: dis ? 0.5 : 1 }}><i className={`fas ${icon}`} /></button>

  const tabNames = ["Apply VLCC Incentives", "VLCC Incentive Approvals", "Producer Incentive Approvals", "VLCC Incentive Updates", "Producer Incentive Updates"]
  const isApprovalTab = tab === 2 || tab === 3
  const isProducerTab = tab === 3 || tab === 5
  const isUpdateTab = tab === 4 || tab === 5

  // Tab columns
  const getCols = () => {
    if (isApprovalTab) {
      const base = ["#", "Company", "Plant", "Chilling Center", "Route", "VLCC"]
      if (isProducerTab) base.push("Producer")
      base.push("Incentive Chart", "Milk Type", "Session", "Effective From", "Validity", "Applied On", "Action")
      return base
    } else {
      const base = ["#", "CC", "Route", "VLCC"]
      if (isProducerTab) base.push("Producer")
      base.push("Incentive Chart", "Milk Type", "Session", "Effective From", "Validity", "Updated In App", "Applied On")
      return base
    }
  }
  const cols = getCols()


  return (<>
    {pageLoad ? <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div> : <>
      <div className="incentivePanel">
        {tabNames.map((n, i) => <span key={i} className={tab === i + 1 ? "acActive" : ""} style={{ cursor: "pointer" }} onClick={() => { setTab(i + 1); setResult(null); setPreviewData([]) }}>{n}</span>)}
      </div>

      {tab === 1 ? (
        <div className="dashBody" style={{ marginTop: 10 }}>
          <div className="font-size-18 mb-0 dashHeader"><Row><Col md={6}><h4>Apply VLCC Incentive Charts</h4></Col></Row></div>
          <div className="dashContent">
            {result && <div className={`alert alert-${result.ok ? "success" : "danger"} py-2`}>{result.msg}</div>}
            <Row>
              <Col md={3}>
                <div className="mb-3">
                  <label className="form-label fw-bold">Apply Incentive</label><br />
                  <label className="me-3"><input type="radio" name="applyTo" value="1" checked={fApplyTo === "1"} onChange={() => { setFApplyTo("1"); setPreviewData([]); setFProducer("") }} /> Common For All Producers</label>
                  <label><input type="radio" name="applyTo" value="2" checked={fApplyTo === "2"} onChange={() => { setFApplyTo("2"); setPreviewData([]) }} /> Producerwise</label>
                </div>
              </Col>
              {showCompany && <Col md={3}><div className="mb-3"><label className="form-label">Company</label><select className="form-select form-select-sm" value={fCompany} onChange={e => onCompanyChange(e.target.value)}><option value="">All</option>{companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div></Col>}
              <Col md={3}><div className="mb-3"><label className="form-label">Plant</label><select className="form-select form-select-sm" value={fPlant} onChange={e => onPlantChange(e.target.value)}><option value="">All</option>{(showCompany && fCompany ? cPlants : allPlants).map(p => <option key={p.id} value={p.id}>{p.name}</option>)}</select></div></Col>
              <Col md={3}><div className="mb-3"><label className="form-label">Chilling Center</label><select className="form-select form-select-sm" value={fCC} onChange={e => onCCChange(e.target.value)}><option value="">All</option>{(fPlant ? cCCs : allCCs).map(c => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div></Col>
              <Col md={3}><div className="mb-3"><label className="form-label">Route</label><select className="form-select form-select-sm" value={fRoute} onChange={e => onRouteChange(e.target.value)}><option value="">All</option>{(fCC ? cRoutes : allRoutes).map(r => <option key={r.id} value={r.id}>{r.routeName || r.name}</option>)}</select></div></Col>
            </Row>
            <Row>
              <Col md={3}><div className="mb-3"><label className="form-label">VLCC</label><select className="form-select form-select-sm" value={fVlcc} onChange={e => onVlccChange(e.target.value)}><option value="">All</option>{(fRoute ? cVlccs : allVlccs).map(v => <option key={v.id} value={v.id}>{v.centerName || v.name}</option>)}</select></div></Col>
              {fApplyTo === "2" && <Col md={3}><div className="mb-3"><label className="form-label">Producer</label><select className="form-select form-select-sm" value={fProducer} onChange={e => { setFProducer(e.target.value); setPreviewData([]) }}><option value="">All</option>{(fVlcc ? cProducers : allProducers).map(p => <option key={p.id} value={p.id}>{p.producerName || p.name}</option>)}</select></div></Col>}
              <Col md={3}>
                <div className="mb-3">
                  <label className="form-label fw-bold">Milk Type <span className="text-danger">*</span></label><br />
                  <label className="me-2"><input type="radio" name="mt" value="1" checked={fMilkType === "1"} onChange={() => setFMilkType("1")} /> Cow</label>
                  <label className="me-2"><input type="radio" name="mt" value="2" checked={fMilkType === "2"} onChange={() => setFMilkType("2")} /> Buffalo</label>
                  <label><input type="radio" name="mt" value="3" checked={fMilkType === "3"} onChange={() => setFMilkType("3")} /> Both</label>
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <label className="form-label fw-bold">Applicable Session <span className="text-danger">*</span></label><br />
                  <label className="me-2"><input type="radio" name="ss" value="3" checked={fSession === "3"} onChange={() => setFSession("3")} /> Both</label>
                  <label className="me-2"><input type="radio" name="ss" value="1" checked={fSession === "1"} onChange={() => setFSession("1")} /> AM</label>
                  <label><input type="radio" name="ss" value="2" checked={fSession === "2"} onChange={() => setFSession("2")} /> PM</label>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={3}><div className="mb-3"><label className="form-label fw-bold">Incentive Chart To Apply <span className="text-danger">*</span></label><select className="form-select form-select-sm" value={fChart} onChange={e => setFChart(e.target.value)}><option value="">Select</option>{charts.map(c => <option key={c.id} value={c.id}>{c.chartName}</option>)}</select></div></Col>
              <Col md={3}><div className="mb-3"><label className="form-label fw-bold">Effective From Date <span className="text-danger">*</span></label><input type="date" className="form-control form-control-sm" value={fFrom} onChange={e => setFFrom(e.target.value)} /></div></Col>
              <Col md={3}>
                <div className="mb-3">
                  <label className="form-label fw-bold">Limit Validity <span className="text-danger">*</span></label><br />
                  <label className="me-2"><input type="radio" name="lv" value="1" checked={fLimitValidity === "1"} onChange={() => setFLimitValidity("1")} /> Yes</label>
                  <label><input type="radio" name="lv" value="0" checked={fLimitValidity === "0"} onChange={() => setFLimitValidity("0")} /> No</label>
                </div>
              </Col>
              {fLimitValidity === "1" && <Col md={3}><div className="mb-3"><label className="form-label fw-bold">Valid Upto <span className="text-danger">*</span></label><input type="date" className="form-control form-control-sm" value={fValidUpto} onChange={e => setFValidUpto(e.target.value)} /></div></Col>}
            </Row>
            <div className="mb-3 text-end">
              <button className="btn btn-primary px-4" onClick={handleShow} disabled={previewLoading}>
                {previewLoading ? <><Spinner size="sm" /> Loading...</> : "Show"}
              </button>
            </div>


            {/* Preview Table */}
            {previewData.length > 0 && <div className="table-responsive">
              <Table className="table mb-0 dairyTbl">
                <thead><tr>
                  <th><input type="checkbox" checked={previewAllChecked} onChange={togglePreviewAll} /></th>
                  <th>Chilling Center</th><th>Route</th><th>Center Number</th><th>Center Name</th>
                  <th>Milk Type</th><th>Incentive Setting</th><th>Existing Inc Chart</th><th>Upcoming Inc Chart</th><th>Status</th>
                </tr></thead>
                <tbody>
                  {previewData.map(r => (
                    <tr key={r.entityId}>
                      <td><input type="checkbox" checked={!!previewChecked[r.entityId]} onChange={() => togglePreviewOne(r.entityId)} /></td>
                      <td>{r.ccName}</td><td>{r.routeName}</td>
                      <td>{r.centerNumber || "\u2014"}</td><td>{r.centerName || "\u2014"}</td>
                      <td><span className={`badge bg-${r.milkType == 1 ? "info" : r.milkType == 2 ? "warning" : "success"}`}>{milkLbl(r.milkType)}</span></td>
                      <td>{r.incSetting || "N/A"}</td>
                      <td>{r.existingChart || "N/A"}</td>
                      <td>{r.upcomingChart || "N/A"}</td>
                      <td>{r.status === "Applicability Type Mismatch" ? <span className="badge bg-danger">{r.status}</span> : r.status === "Active" ? <span className="badge bg-success">{r.status}</span> : <span className="badge bg-primary">{r.status}</span>}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="text-end mt-3">
                <button className="btn btn-success px-4" onClick={handleApplySelected} disabled={applyingSelected || previewSelectedCount === 0}>
                  {applyingSelected ? <><Spinner size="sm" /> Applying...</> : `Apply Selected Incentive Charts`}
                </button>
              </div>
            </div>}
          </div>
        </div>
      ) : (


        /* Tabs 2-5: Data tables */
        <div className="dashBody" style={{ marginTop: 10 }}>
          <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <h4 style={{ margin: 0 }}>{tabNames[tab - 1]}</h4>
              {canDelete(MID) && ib("#dc3545", "fa-trash", `Delete ${selectedCount}`, () => { if (selectedCount > 0) { setConfirmType("delete"); setconfirm_alert(true) } else alert("Select items first") }, !selectedCount)}
              {isApprovalTab && ib("#28a745", "fa-check", `Approve ${selectedCount}`, () => { if (selectedCount > 0) { setConfirmType("approve"); setconfirm_alert(true) } else alert("Select items first") }, !selectedCount)}
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <input type="text" className="form-control form-control-sm" placeholder="Search" style={{ width: 180, borderRadius: "4px 0 0 4px" }} value={search} onChange={e => setSearch(e.target.value)} />
              <button className="btn btn-primary btn-sm" style={{ borderRadius: "0 4px 4px 0", height: 31 }}><i className="fas fa-search" /></button>
            </div>
          </div>
          <div className="table-responsive">
            <Table className="table mb-0 dairyTbl">
              <thead><tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
                {cols.map((c, i) => <th key={i}>{c}</th>)}
              </tr></thead>
              <tbody>
                {tabLoading ? <tr><td colSpan={cols.length + 1}><img className="loaderImg" src={loader} alt="Loading" /></td></tr>
                  : paged.length > 0 ? paged.map((r, i) => (
                    <tr key={r.id}>
                      <td><input type="checkbox" checked={!!checkedItems[r.id]} onChange={() => handleCheckbox(r.id)} /></td>
                      <td>{(page - 1) * perPage + i + 1}</td>
                      {isApprovalTab && <td>{getName(companies, r.company)}</td>}
                      {isApprovalTab && <td>{getName(allPlants, r.plant)}</td>}
                      <td>{getName(allCCs, r.chillingCenter)}</td>
                      <td>{getName(allRoutes, r.route, "routeName")}</td>
                      <td>{getName(allVlccs, r.vlcc, "centerName")}</td>
                      {isProducerTab && <td>{getProducerName(r.producer)}</td>}
                      <td>{getName(charts, r.incentiveChart, "chartName")}</td>
                      <td><span className={`badge bg-${r.milkType == 1 ? "info" : r.milkType == 2 ? "warning" : "success"}`}>{milkLbl(r.milkType)}</span></td>
                      <td>{sessLbl(r.session)}</td>
                      <td style={{ fontSize: 12 }}>{r.from || "\u2014"}</td>
                      <td style={{ fontSize: 12 }}>{r.limitValidity === "1" ? r.validUpto || "\u2014" : "No Limit"}</td>
                      {isUpdateTab && <td>{r.updatedInApp ? <span className="badge bg-success">Yes</span> : <span className="badge bg-secondary">No</span>}</td>}
                      <td style={{ fontSize: 12 }}>{r.appliedOn ? r.appliedOn.slice(0, 10) : r.approvedAt ? (typeof r.approvedAt === "string" ? r.approvedAt.slice(0, 10) : "\u2014") : r.created_at?.slice(0, 10) || "\u2014"}</td>
                      {isApprovalTab && <td>
                        <button title="Approve" onClick={() => handleSingleApprove(r.id)} style={{ width: 26, height: 26, borderRadius: 4, background: "#28a745", color: "#fff", border: "none", fontSize: 11, cursor: "pointer" }}><i className="fas fa-check" /></button>
                      </td>}
                    </tr>
                  )) : <tr><td colSpan={cols.length + 1} className="text-center py-4">No matching records found</td></tr>}
              </tbody>
            </Table>
          </div>
          {totalPages > 1 && <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 4, marginTop: 12 }}>
            <button className="btn btn-sm btn-outline-secondary" disabled={page <= 1} onClick={() => setPage(1)}>{"\u00AB"}</button>
            <button className="btn btn-sm btn-outline-secondary" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>{"\u2039"}</button>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => { const s = Math.max(1, Math.min(page - 2, totalPages - 4)); const p = s + i; return p <= totalPages ? <button key={p} className={`btn btn-sm ${p === page ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setPage(p)}>{p}</button> : null })}
            <button className="btn btn-sm btn-outline-secondary" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>{"\u203A"}</button>
            <button className="btn btn-sm btn-outline-secondary" disabled={page >= totalPages} onClick={() => setPage(totalPages)}>{"\u00BB"}</button>
          </div>}
        </div>
      )}
    </>}

    {confirm_alert && <SweetAlert title={confirmType === "delete" ? `Delete ${selectedCount} item(s)?` : `Approve ${selectedCount} item(s)?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
      onConfirm={() => { handleBulkAction(confirmType); setconfirm_alert(false) }}
      onCancel={() => setconfirm_alert(false)}>{confirmType === "delete" ? "This cannot be undone!" : "Approve selected incentives?"}</SweetAlert>}
    {success_dlg && <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>}
  </>)
}
export default VLCCIncentives

